var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","data-theme":"default"}},[(_vm.init)?_c('Layout'):_vm._e(),_c('ModalLogin',{ref:"modalLogin"}),_c('Toast'),_c('InfoWindowHandler'),_c('Message')],1)}
var staticRenderFns = []

export { render, staticRenderFns }